<template>
  <cxco-root class="cxco">
    <main class="cxco-o-faq">
      <section class="cxco-o-faq__content">
        <h1 class="cxco-o-faq__title">{{ title }}</h1>
        <SearchBar />
        <BreadCrumbs />
        <Categories />
        <Faqs />
      </section>
    </main>
  </cxco-root>
</template>

<script>
import store from "./store";
import BreadCrumbs from "./views/breadcrumbs";
import SearchBar from "./views/searchbar";
import Categories from "./views/categories";
import Faqs from "./views/faqs";
import defaultStyles from "./styles/main.scss";
import { addStyles } from "./utils/index";
import { provide } from "vue";
const { actions, state } = store;

export default {
  components: { BreadCrumbs, SearchBar, Categories, Faqs },
  setup() {
    provide("state", state);
    provide("actions", actions);
  },
  computed: {
    title() {
      return state.title;
    },
  },
  async beforeCreate() {
    await actions.getCategoryTree();
  },
  mounted() {
    addStyles(this.$el, defaultStyles[0][1], "default");
    addStyles(this.$el, state.style, "custom");
  },
};
</script>
